/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import imageFamilyLaw from "../../assets/img/products/Illustration_Familienrecht.svg";
import imageFamilyLawDark from "../../assets/img/products/Illustration_Familienrecht_dark.svg";
import imageEmploymentLaw from "../../assets/img/products/Illustration_Arbeitsrecht.svg";
import imageEmploymentLawDark from "../../assets/img/products/Illustration_Arbeitsrecht_dark.svg";
import imageTrafficLaw from "../../assets/img/products/Illustration_Verkehrsrecht.svg";
import imageTrafficLawDark from "../../assets/img/products/Illustration_Verkehrsrecht_dark.svg";
import ThemedIllustration from "../ThemedIconSwitch/ThemedIllustration";

const linkedCardsGuidebook = [
  {
    icon:  <ThemedIllustration lightIllustration={imageFamilyLaw} darkIllustration={imageFamilyLawDark} />,
    heading: "Familienrecht",
    subHeading: "",
    link: "/ratgeber/familienrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageEmploymentLaw} darkIllustration={imageEmploymentLawDark} />,
    heading: "Arbeitsrecht",
    subHeading: "",
    link: "/ratgeber/arbeitsrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageTrafficLaw} darkIllustration={imageTrafficLawDark} /> ,
    heading: "Verkehrsrecht",
    subHeading: "",
    link: "/ratgeber/verkehrsrecht",
  },
];

export default linkedCardsGuidebook;
